import { useRef, useCallback } from 'react';
import '../useSSRLayoutEffect/index.js';
import useSSRLayoutEffect from '../useSSRLayoutEffect/useSSRLayoutEffect.js';

/**
 * An abstraction on top of `useCallback` that does not trigger a re-render when the function parameter changes.
 * @param fn - The function to memoize.
 * @returns A memoized version of the function that never changes.
 * @see https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */
function useEventCallback(fn) {
  const fnRef = useRef(fn);
  useSSRLayoutEffect(() => {
    fnRef.current = fn;
  });
  return useCallback(event =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: Left side of comma operator is unused and has no side effects. See https://stackoverflow.com/questions/11541134/javascript-syntax-0-fnargs
  (0, fnRef.current)(event), []);
}

export { useEventCallback as default };
